import React from 'react'
import Breadcrumbs from '../../../common/breadcrumb/Breadcrumbs'
import RupayGiftCardFill from './rupayGiftCardFill/RupayGiftCardFill'
import RupayGiftCardList from './rupayGiftCardList/RupayGiftCardList'

function RupayGiftCard() {
  return (
    <>
    <Breadcrumbs breadCrumbsTitle={""}/>
    <RupayGiftCardFill/>
    <RupayGiftCardList/>
    </>

  )
}

export default RupayGiftCard